<template>
  <div>
    <b-navbar
      class="d-none d-md-flex"
      :class="{shadow: scroll}"
      id="navbarText"
    >
      <!-- <b-container-fluid> -->
      <!-- Logo del cliente centrado -->
      <b-navbar-brand href="/home" class="logo-container mx-auto">
        <img
          :src="logoSrc"
          class="header-logo client-logo"
          alt="logo"
        />
      </b-navbar-brand>

      <!-- <b-navbar-nav class="">
        <b-nav-item >
		{{$store.state.userName}}
        </b-nav-item >
        <b-nav-item @click.prevent="toggleLanguage()">
          <img
            src="../../assets/imgs/es.png"
            alt="es"
            v-if="language == 'es-ES'"
          />
          <img src="../../assets/imgs/en.png" alt="en"  v-else />
        </b-nav-item>
      </b-navbar-nav> -->
      <b-dropdown
        v-if="isAuthenticated"
        end
        variant="link"
        toggle-class="user-pill-toggle text-decoration-none"
        menu-class="user-pill-menu-wrap"
        class="ml-auto mr-3"
      >
        <template #button-content>
          <span class="font-weight-bold">{{ currentUserName }}</span>
        </template>
        <div class="user-pill-menu-holder">
          <button type="button" class="user-pill-menu-button" @click="logout()">
            <span v-if="language == 'es-ES'">Cerrar Sesión</span>
            <span v-else>Logout</span>
          </button>
        </div>
      </b-dropdown>
      <!-- </b-collapse> -->
      <!-- </b-container-fluid> -->
    </b-navbar>
  </div>
</template>

<script>
import Authentication from "@/services/Authentication"
import User from "@/services/User"

const imageContext = require.context("../../assets/imgs", false, /\.(png|jpe?g|svg)$/i);

export default {
	name: "AppHeader",
	data() {
		return {
			icono: "",
			compania: "",
			menu: "",
			home: "/#home",
			scroll: false,
			currentUserDisplayName: ""
		};
	},
	beforeMount() {
		window.addEventListener("scroll", this.scrollFunction);
		if(this.$store.state.isAuthenticated){
			const now = new Date();
			const expiresIn = (new Date(this.$store.state.expiration)).getTime() - now.getTime();
			setTimeout(() => {
				console.log("YAY")
				this.logout()
			}, expiresIn);
		}
	},
	methods: {
		scrollFunction(e) {
			this.scroll = window.pageYOffset > 300
			e.preventDefault()
		},
		logout: function() {
			const obj = {
				token: "",
				username: "",
				role: "",
				expiresIn: "",
				isAuthenticated: false,
			};
			this.$store.commit("setData", obj);
			this.$router.push("/");
		},
		toggleLanguage() {
			if (this.$store.state._language == "es-ES") {
				this.$store.commit("setLang", "en-US");
			} else {
				this.$store.commit("setLang", "es-ES");
			}
		},
		loadCurrentUserName() {
			const userId = this.$store.state.userId;
			if (!this.$store.state.isAuthenticated || !userId) return;
			if (this.$store.state.userName) {
				this.currentUserDisplayName = this.$store.state.userName;
				return;
			}
			User.getAllUsersById(userId)
				.then((res) => {
					this.currentUserDisplayName = res?.data?.exiteUser?.[0]?.nombre || "";
				})
				.catch(() => {});
		},
	},
	computed: {
		logoSrc() {
			const fallback = imageContext("./logo-login.png");
			if (!this.icono) {
				return fallback;
			}

			const candidates = [this.icono, `${this.icono}.png`, `${this.icono}.jpg`, `${this.icono}.jpeg`];
			for (const file of candidates) {
				try {
					return imageContext(`./${file}`);
				} catch (e) {
					// Continue trying other extensions/names.
				}
			}
			return fallback;
		},
		role() {
			// console.log(this.$store.state.userRole)
			return this.$store.state.userRole;
		},
		isAuthenticated() {
			// console.log(this.$store.state.isAuthenticated)
			return this.$store.state.isAuthenticated;
		},
		language() {
			// console.log(this.$store.state._language)
			return this.$store.state._language;
		},
		currentUserName() {
			return this.$store.state.userName || this.currentUserDisplayName || "";
		},
	},
	mounted() {
		Authentication.leaParametros()
		.then ((result) => {
			this.icono = result.data.parametros.icono
			this.compania = result.data.parametros.compania
		})
		this.loadCurrentUserName()
	}
}
</script>